import React, { createRef, useEffect, useMemo, useRef } from 'react'
import styled from 'styled-components'
import { Link, useHistory } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Controller, Scene } from 'react-scrollmagic';
import OvercomeAnimate from 'resources/overcome-animate.svg'
import { isMobile } from 'react-device-detect'

import { Button, ListTile } from 'components'
import { Header, Footer } from 'features'
import { FeatureList } from './FeatureList'
import { Banner } from './Banner'
import { motion } from 'framer-motion'
import { ListPreview, ListPreviewSmall, KanbanPreview, CommandPreview } from './features'
import { FaRegCopyright, FaInstagramSquare, FaLinkedin, FaMedium } from 'react-icons/fa'

import classes from './LandingScreen.module.css'
import * as cssTheme from '../../theme'

const Tab = styled.div`
    font-family: 'Courier New';
    background-color: white;
    cursor: pointer;
    width: 10rem;
    padding: 0.5rem;
    border-radius: 5px;
    color: black;
    text-align: center; 
`

const LandingScreen = props => {
    const indicators = false;
    const [selectedTab, setTab] = React.useState(1)
    const [scrollY, setScrollY] = React.useState(null)
    const selectorsRef = useRef()
    const listPreviewRef = useRef()
    const landingRef = useRef()
    const refs= useMemo(
        () => Array.from({ length: 4 }).map(() => createRef()),[]
    );
    let history = useHistory()
    useEffect(() => {
        AOS.init()

        document.addEventListener('scroll', () => {
            const y = selectorsRef.current && selectorsRef.current.getBoundingClientRect()['y']
            scrollY === 0 | !scrollY & y > 0 && setScrollY(1)  
            scrollY !== 0 & y === 0 && setScrollY(0)
            const ys = refs.map(ref => (ref.current && ref.current.getBoundingClientRect()['bottom'] - (16 * 5))) // 16 * 5 == 1rem * 5, to account for selectors tab

            if(ys[3] && ys[3] < window.innerHeight){
                setTab(3)
            } else if(ys[0] > 0){
                setTab(0)
            } else {
                const negatives = ys.filter(value =>  (value < 0))
                setTab(negatives.length)
            }
        });

        // Make sure dark theme
        let theme = cssTheme.dark;
		for (const [key, value] of Object.entries(theme)) {
		document.documentElement.style.setProperty(key,value);
		}

		for (const [key, value] of Object.entries(cssTheme.base)) {
		document.documentElement.style.setProperty(key,value);
		}

        // document.addEventListener('aos:in:call-to-action', ({ detail }) => {
        //     console.log('animated in', detail);
        //     setTab(3)
        // });
    }, [])


    // Styles
    const buttonStyle = {
        backgroundColor: '#2B2B2B',
        boxShadowColor: 'transparent'
    }
    const registerStyle = {
        backgroundColor: '#957fef',
    }
    const actionStyle = {
        backgroundColor: '#957fef',
        fontSize: '1.2rem',
        padding: isMobile ? '0.5rem' : '1rem',
        fontWeight: 'bold',
        margin: 0,
        width: !isMobile && '15rem'
    }
    const footerStyle = {
        backgroundColor: '#2B2B2B',
        boxShadowColor: 'transparent',
        margin: 0,
        fontSize: '1rem'
    }

    const listTileStyle = {
        backgroundColor: 'transparent',
        margin: '0.5rem 0',
        padding: 0
    }

    const selectTab = (value) => {
        // selectedTab !== value && setTab(value)
        // refs[value - 1].current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        const offset = value%2 !== 0 ? 90 : 60
        const y = refs[value].current.getBoundingClientRect()['y'] + window.scrollY - offset
        window.scrollTo({top: y, behavior: 'smooth'});
    }

    return (
        <div className={classes.LandingScreen} ref={landingRef}>
            {/* Header */}
            <Header/>

            {/* Body */}
            <div className={classes.Body}>
                {/* Banner */}
                <div className={classes.Banner}>
                    <div className={classes.BannerText}>
                        <div className={classes.BannerTitle}>Productivity</div>
                        <div className={classes.Title}>for individuals</div>
                        <div className={classes.Subtitle}>A simple but significant way to organize your workflow</div>
                        <Button text="Get started - it's free" styles={actionStyle} onSelect={() => history.push('/register')}/>
                    </div>
                </div>

                {/* Selectors */}
                {selectedTab !== 3 && <div className={classes.Selectors} ref={selectorsRef}>
                    <div className={selectedTab === 0 ? classes.SelectedSelector : classes.Selector} onClick={() => selectTab(0)}>List view</div>
                    <div className={selectedTab === 1 ? classes.SelectedSelector : classes.Selector} onClick={() => selectTab(1)}>Kanban board</div>
                    <div className={selectedTab === 2 ? classes.SelectedSelector : classes.Selector} onClick={() => selectTab(2)}>Command bar</div>
                    {/* <div className={selectedTab === 3 ? classes.SelectedSelector : classes.Selector} onClick={() => selectTab(3)}>Command bar</div>
                    <div className={selectedTab === 4 ? classes.SelectedSelector : classes.Selector} onClick={() => selectTab(4)}>Rich text</div> */}
                    {scrollY === 0 & window.innerWidth > 1000 ? <Button text='Get started' styles={registerStyle} onSelect={() => history.push('/register')}/> : null}
                </div>}

                {/* List section */}
                <div className={classes.Tile} ref={refs[0]}>
                    <div className={classes.SectionTitle} data-aos="fade-up">Manage tasks effortlessly</div>
                    
                    <div className={classes.ListSection} ref={listPreviewRef}>

                        <Controller>
                            <Scene duration={refs[0].current && refs[0].current.getBoundingClientRect()['height']} indicators={indicators}>
                                {(progress, event) => (
                                    <div>
                                        <div className={classes.Wrapper}>
                                            <div className={classes.ListBodySection}>
                                                <div className={classes.Title_s1}>Task management</div>
                                                <div className={classes.Subtitle2}>Capture and organize tasks effortlessly</div>
                                            </div>
                                        </div>
                                        {/* <div className={classes.Wrapper}>
                                            <div className={classes.ListBodySection}>
                                                <div className={classes.Title_s2}>Children management</div>
                                                <div className={classes.Subtitle2}>Sub-tasks are just one tab away</div>
                                            </div>
                                        </div> */}
                                        <div className={classes.Wrapper}>
                                            <div className={classes.ListBodySection}>
                                                <div className={classes.Title_s3}>Time blocking</div>
                                                <div className={classes.Subtitle2}>Quickly schedule tasks by dropping it into your schedule</div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Scene>
                        </Controller>

                    </div>

                    <Controller>
                        <Scene duration={refs[0].current && refs[0].current.getBoundingClientRect()['height']} indicators={indicators}>
                            {(progress, event) => (
                                <div className={classes.ListPreview} >
                                    <div className={classes.ListPreviewElement}>
                                        {window.innerWidth > 600 ? <ListPreview progress={progress}/> : <ListPreviewSmall progress={progress}/>}
                                    </div>
                                </div>
                            )}
                        </Scene>
                    </Controller>
                </div>
                
                {/* Kanban section */}
                <div className={classes.Tile2} ref={refs[1]}>
                    <div className={classes.SectionTitle} style={{textAlign: 'center'}} data-aos="fade-up">Switch your view</div>
                    <div className={classes.KanbanSection}>
                        <Controller>
                            <Scene duration={refs[1].current && refs[1].current.getBoundingClientRect()['height']} indicators={indicators}>
                                {(progress, event) => (
                                    <div>
                                        <div className={classes.KanbanPreview} >
                                            <div className={classes.KanbanPreviewElement}><KanbanPreview progress={progress}/></div>
                                        </div>
                                        
                                        <div className={classes.KanbanBody}>
                                            <div className={classes.KanbanBodySection}>
                                                <div className={classes.KanbanContent}>
                                                    <div className={classes.KanbanTitle}>
                                                        <div className={classes.Title_s1}>Prioritize</div>
                                                        <div className={classes.Subtitle2}>Organize your work according to what matters the most to you</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={classes.KanbanBodySection}>
                                                <div className={classes.KanbanContent}>
                                                <div className={classes.KanbanTitle}>
                                                        <div className={classes.Title_s2}>Tagging</div>
                                                        <div className={classes.Subtitle2}>Make use of tags and scheduling your tasks to further segregate and identify your items</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Scene>
                        </Controller>
                    </div>
                </div>
                
                <div style={{backgroundColor: '#2B2B2B', height: '5rem', width: '100%', zIndex: 2}}/>
                
                {/* Search section */}
                <div className={classes.Tile3} ref={refs[2]} style={{marginBottom: '0 !important'}}>
                    <div className={classes.SectionTitle} data-aos="fade-up">Power up your productivity</div>
                    
                    <div className={classes.ListSection} ref={listPreviewRef}>
                        <Controller>
                            <Scene duration={refs[2].current && refs[2].current.getBoundingClientRect()['height']} indicators={indicators}>
                                {(progress, event) => (
                                    <div>
                                        <div className={classes.Wrapper}>
                                            <div className={classes.ListBodySection}>
                                                <div className={classes.Title_s1}>Quick search</div>
                                                <div className={classes.Subtitle2}>Find what you need effortlessly</div>
                                            </div>
                                        </div>
                                        
                                        <div className={classes.Wrapper}>
                                            <div className={classes.ListBodySection}>
                                                <div className={classes.Title_s3}>Your day</div>
                                                <div className={classes.Subtitle2}>Find out what's going on today, tomorrow or any other day</div>
                                            </div>
                                        </div>

                                        <div className={classes.Wrapper}>
                                            {progress < 0.95 && 
                                            <div className={classes.ListBodySection}>
                                                <div className={classes.Title_s2}>Categorize</div>
                                                <div className={classes.Subtitle2}>Make use of tags to fine tune your tasks</div>
                                            </div>}
                                        </div>
                                    </div>
                                )}
                            </Scene>
                        </Controller>
                    </div>

                    <Controller>
                        <Scene duration={listPreviewRef.current && listPreviewRef.current.getBoundingClientRect()['height']} indicators={indicators}>
                            {(progress, event) => (
                                <div className={classes.CommandPreview} >
                                    <div className={classes.CommandPreviewElement}><CommandPreview progress={progress}/></div>
                                </div>
                            )}
                        </Scene>
                    </Controller>
                </div>
            </div>

            <div className={classes.ActionSection} ref={refs[3]} data-aos="fade-up" data-aos-id="call-to-action">
                <div className={classes.GlassWrapper}>
                    <div className={classes.ActionText}>Ready to get things</div>
                    <div style={{display: 'grid', gridColumnGap: '0.5rem', gridTemplateColumns: 'auto auto', marginBottom: '0.5rem'}}>
                        <div className={classes.ActionTitle}>Atomicly</div>
                        <div className={classes.ActionText}>done?</div>
                    </div>
                    <Button text="Try for free" styles={{backgroundColor: '#957fef', fontSize: '1rem', padding: isMobile ? '0.5rem' : '0.75rem', margin: 0, width: '10rem'}} onSelect={() => history.push('/register')}/>
                </div>
                <img className={classes.BannerImg} src={OvercomeAnimate}/> 
            </div>
            
            <Footer/>
            
        </div>
    )
}

export default LandingScreen;